import * as React from 'react';
import BarcodeOutlined from './barcode-outlined';
import BarcodeFilled from './barcode-filled';
import type { IconCombinedProps } from './types';
const BarcodeCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <BarcodeFilled ref={ref} {...rest} />;
  }
  return <BarcodeOutlined ref={ref} {...rest} />;
});
export default BarcodeCombined;